<template>
<div class="form">
  <breadcrumb :items="[{ text: 'Fornecedores', to: '/fornecedores' }, { text: supplier ? supplier.name : 'Cadastrar fornecedor', active: true }]" />
  <b-form @submit.prevent="save" v-if="!isLoading">
    <b-tabs small card ref="tabs" v-model="tab">
      <b-tab title="Registro">
        <b-form-group label="CNPJ">
          {{form.cnpj | cnpj}}
        </b-form-group>
        <b-form-group label="Nome da organização">
          <b-form-input v-model="form.name" name="name" />
        </b-form-group>
        <b-form-group label="Atividade principal">
          <b-form-input v-model="form.description" name="description" />
        </b-form-group>
        <b-form-group label="Redes que englobam esta organização *" v-if="isAdmin">
          <form-entities-select type="organizations" :form="form" field="organizations" />
          <field-error :msg="veeErrors" field="organizations" />
        </b-form-group>
      </b-tab>
      <b-tab title="Apresentação">
        <b-form-group label="Histórico do fornecedor" description="Escreva um breve resumo da história do fornecedor">
          <b-form-textarea v-model="form.history" name="history" />
        </b-form-group>
        <form-links :form="form" field="links" />
        <pictures-upload :form="form" :error="error" field="images" url="uploads/images" :multiple="true"  />
      </b-tab>
      <b-tab title="Contato">
        <b-form-group label="Endereço">
          <span v-if="form.address" class="text-black">{{form.address.description}}</span>
          <location :cb="setAddress" :current_address="form.address" :autoload="false" />
        </b-form-group>
        <form-phones :form="form" field="phones" />
        <form-whats-app :form="form" field="whatsapp" />
        <b-form-group label="Email">
          <b-form-input v-model="form.email" name="email" />
        </b-form-group>
        <form-contact-persons :form="form" field="contact_persons" />
      </b-tab>
      <b-tab title="Financeiro">
        <b-form-group label="Formato jurídico">
          <b-form-input v-model="form.legal_format" name="legal_format" />
        </b-form-group>
        <b-form-group label="Regime tributário">
          <b-form-input v-model="form.tax_regime" name="tax_regime" />
        </b-form-group>
        <b-form-group label="Inscrição estadual">
          <b-form-input v-model="form.state_registration" name="state_registration" />
        </b-form-group>
        <b-form-group label="Inscrição">
          <b-form-input v-model="form.subscription" name="subscription" />
        </b-form-group>
        <form-bank-account :form="form" />
        <b-form-group label="Emite nota fiscal?">
          <b-form-checkbox v-model="form.issue_invoice" name="issue_invoice" />
        </b-form-group>
      </b-tab>
      <b-tab title="Usuários">
        <form-users :supplier="supplier" />
      </b-tab>
    </b-tabs>
    <form-submit :errors="error" :sending="isSending" label="Continuar" />
  </b-form>
</div>
</template>

<script>
import axios from 'axios'
import Location from '@/components/Location'
import FormBankAccount from '@/components/FormBankAccount'
import FormSubmit from '@/components/FormSubmit'
import FormLinks from '@/components/FormLinks'
import FormPhones from '@/components/FormPhones'
import FormWhatsApp from '@/components/FormWhatsApp'
import FormContactPersons from '@/components/FormContactPersons'
import FormEntitiesSelect from '@/components/FormEntitiesSelect'
import FieldError from '@/components/FieldError'
import PicturesUpload from '@/components/PicturesUpload'
import FormUsers from '@/components/FormUsers'

export default {

  name: 'SupplierForm',
  data() {
    return {
      tab: 1,
      form: {
        organizations: [],
        cnpj: '',
        email: '',
        name: '',
        description: '',
        password: '',
        history: "",
        address: null,
        images: [],
        links: [],
        phones: [],
        whatsapp: [],
        contact_persons: [],
        legal_format: "",
        tax_regime: "",
        subscription: "",
        state_registration: "",
        bank_account: {
          bank_number: '',
          agency: '',
          account: '',
          type: 'corrente',
        },
        issue_invoice: false
      },
      supplier: null,
    }
  },
  created() {
    this.edit(this.$route.params.id)
  },
  methods: {
    edit(id) {
      this.isLoading = true
      axios.get('suppliers/' + id, {
        params: {
          populate: 'users'
        }
      }).then(response => {
        this.apiDataToForm(this.form, response.data)
        this.supplier = response.data
        this.isLoading = false
      }).catch(this.showError);
    },
    save() {
      this.$validator.validate().then(isValid => {
        if (isValid) {
          this.isSending = true
          this.error = false
          axios({
            method: 'PUT',
            url: 'suppliers/' + this.$route.params.id,
            data: this.form
          }).then(resp => {
            var supplier = resp.data
            if (supplier && supplier._id) {
              this.notify("Os dados foram salvos!")
              if (this.tab == 4) {
                this.$router.replace('/fornecedores')
              } else {
                window.scrollTo(0,0);
                this.tab += 1
              }
            }
            this.isSending = false
          }).catch(this.showError)
        }
      })
    },
    setTab(tab) {
      this.tab = tab
    },
    setAddress(address) {
      this.form.address = address
    }
  },
  components: {
    Location,
    FormBankAccount,
    FormSubmit,
    FormLinks,
    FormPhones,
    FormWhatsApp,
    FormContactPersons,
    FormEntitiesSelect,
    FieldError,
    PicturesUpload,
    FormUsers
  }
};
</script>
